<template>
<!-- 工人短信接收列表 -->
    <div>
        <el-table :data="workerMsgList" :header-cell-style="{'text-align':'center'}" id="workDetailsTable"
            :cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600">
            <el-table-column v-for="(obj,key,index) in workerMsgKeys" :key="index"
              :label="obj.value" :prop="key" :width="obj.width"/>
        </el-table>
        <el-pagination
            style="text-align: center"
            background
            layout="prev, pager, next"
            @current-change="getMsgList"
            :page-size="pageInfo.size"
            :current-page="pageInfo.page"
            :page-count="totalPages">
        </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/factory/user/list'
export default {
    data() {
        return {
            workerMsgList: [],
            workerMsgKeys: {
                message: { value: '类型', width: '70' },
                worker: { value: '工人姓名', width: '80' },
                machineNumber: { value: '机台编号', width: '80' },
                machineWorkShop: { value: '所处车间', width: '80' },
                noticeTime: { value: '短信接收时间', width: '' }
            },
            pageInfo: {
                page: 1,
                size: 10
            },
            totalPages: 0
        }
    },
    methods: {
        // 获取工人短信接收分页列表
        getMsgList(page) {
            const copy = { page, size: this.pageInfo.size }
            return api.getMsgList(copy).then(res => {
                this.workerMsgList = this.formatWorkerMsgList(res.data.list)
                this.totalPages = res.data.pages
                this.pageInfo.page = page
            })
        },
        // 格式化工人短信接收列表
        formatWorkerMsgList(response) {
            const workerMsgList = []
            response.forEach((item) => {
              item.workers.forEach((worker) => {
                const title = `[${item.message}][${item.machineNumber}(${item.machineWorkShop})]${worker}`
                workerMsgList.push({
                  title,
                  worker,
                  id: item.id,
                  machineId: item.machineId,
                  machineNumber: item.machineNumber,
                  machineWorkShop: item.machineWorkShop,
                  message: item.message,
                  noticeTime: this.utils.timestampToTime(item.noticeTime)
                })
              })
            })
            return workerMsgList
        }
    },
    created() {
        this.getMsgList(1)
    }
}
</script>

<style scoped lang="scss">

</style>
